import { render } from "./ServersTable.vue?vue&type=template&id=2f83207c"
import script from "./ServersTable.vue?vue&type=script&lang=ts"
export * from "./ServersTable.vue?vue&type=script&lang=ts"

import "./ServersTable.vue?vue&type=style&index=0&id=2f83207c&lang=css"
script.render = render

export default script